// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1jmhv","content":"RecentSearches_content__3USK5"};